import React from 'react';
import {Route as BaseRoute} from 'react-router';

export const Route = ({path, exact = undefined, strict, component: Component}) => (
  <BaseRoute {...(path ? {path, exact: undefined !== exact ? exact : true, strict} : {exact})}>
    <Component />
  </BaseRoute>
);

export default Route